var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAndText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 37,
    viewBox: "0 0 134 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2132_7025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 34C26.8366 34 34 26.8366 34 18C34 9.16344 26.8366 2 18 2C9.16344 2 2 9.16344 2 18C2 26.8366 9.16344 34 18 34Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2128 23.566C21.0416 24.454 19.5821 24.9818 17.9989 24.9818C16.4076 24.9818 14.9415 24.4486 13.7674 23.5521L10.2187 27.0619C12.3093 28.8583 15.0262 29.9467 17.9989 29.9467C20.9579 29.9467 23.6634 28.8686 25.7501 27.0868L22.2128 23.566Z",
    fill: "#00B2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7777 16.3185C24.911 16.8574 24.9828 17.4203 24.9828 18.0001C24.9828 19.5719 24.4633 21.0221 23.5868 22.1889L27.1237 25.7094C28.9381 23.5619 29.9481 20.8327 29.9481 18.0001C29.9481 16.069 29.4772 14.1835 28.601 12.4956L24.7777 16.3185Z",
    fill: "#FF4F42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3996 22.1708C11.5311 21.007 11.0171 19.5639 11.0171 17.9999C11.0171 14.1439 14.1429 11.0181 17.9989 11.0181C19.1139 11.0181 20.1669 11.2807 21.1019 11.7456L24.7076 8.13953C22.7899 6.82555 20.4776 6.05298 17.9989 6.05298C11.4449 6.05298 6.05212 11.4461 6.05212 17.9999C6.05212 20.8187 7.05225 23.536 8.85192 25.6796L12.3996 22.1708Z",
    fill: "#17C22E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3115 20.8742C17.0007 20.8742 16.6895 20.7556 16.4525 20.5183L14.1059 18.1719C13.6313 17.6975 13.6313 16.9283 14.1059 16.4541C14.5799 15.9795 15.3496 15.9795 15.8238 16.4541L17.3115 17.9414L26.8042 8.44885C27.2783 7.97425 28.0481 7.97425 28.5222 8.44885C28.9968 8.9231 28.9968 9.6925 28.5222 10.1669L18.1704 20.5183C17.9333 20.7556 17.6223 20.8742 17.3115 20.8742Z",
    fill: "#212529"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.449 24.5406H47.7857V14.6969H52.2347V11.4474L40 11.4156V14.6969H44.449V24.5406Z",
    fill: "#212529"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1327 22.3531L57.796 17.9999V24.5406H54.4592V11.4156L56.6837 11.4474L61.1327 16.8844L65.5817 11.4474L67.8062 11.4156V24.5406H64.4695V17.9999L61.1327 22.3531Z",
    fill: "#212529"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0409 19.0719H74.4797V21.7594H82.2654V24.5723L71.1429 24.5723V11.4156H82.2654V14.15H74.4797V16.8844H80.0409V19.0719Z",
    fill: "#212529"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.51 21.2594H102.286V24.5724H98.9492V11.4156H105.067C108.403 11.4156 110.628 13.0508 110.628 16.3375C110.628 18.5196 108.959 20.1656 107.847 20.7125L111.184 24.5406H107.291L104.51 21.2594ZM107.291 16.3375C107.291 14.6969 106.179 14.15 104.51 14.15H102.286V18.4999L104.51 18.525C106.179 18.525 107.291 17.9781 107.291 16.3375Z",
    fill: "#212529"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.521 24.5406V11.4156H117.857V24.5406H114.521Z",
    fill: "#212529"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2757 24.5724L88.9389 24.5723V14.7286H84.4899V11.4474H96.7247V14.7286H92.2757V24.5724Z",
    fill: "#212529"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134 22.5393C132.674 24.0451 130.701 25 128.498 25C124.506 25 121.27 21.866 121.27 18C121.27 14.134 124.506 11 128.498 11C130.7 11 132.673 11.9541 133.998 13.4587L131.433 15.514C130.736 14.6462 129.68 14.0931 128.498 14.0931C126.397 14.0931 124.694 15.8423 124.694 18.0001C124.694 20.1578 126.397 21.907 128.498 21.907C129.681 21.907 130.737 21.3531 131.435 20.484L134 22.5393Z",
    fill: "#212529"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2132_7025",
    x: 0,
    y: 0.5,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0578824 0 0 0 0 0.109333 0 0 0 0 0.160784 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2132_7025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2132_7025",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAndText);
export default __webpack_public_path__ + "static/media/logo_and_text.dfd5a22e649d8f0f1b48e977f08e5592.svg";
export { ForwardRef as ReactComponent };